import { ColumnBodyOptions } from 'primereact/column';
import dayjs from 'dayjs';
import { chain, get, isArray, isObject } from 'lodash';
import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { isAxiosError } from 'axios';
import { ToastMessage } from 'primereact/toast';
import { AdubacaoRow, TalhaoRow, UnidadeConversao } from '../../../@types';
import { TalhaoError } from '../../../services';

export const NUMBER_FORMAT_OPTIONS = {
  maximumFractionDigits: 3,
  useGrouping: true,
};

export const TO_GRAMAS = 0.001;

export const getConversionToGramas = (
  unidadeConversao?: UnidadeConversao | null,
) => {
  if (!unidadeConversao) return 1;

  return unidadeConversao.taxa / TO_GRAMAS;
};

export const dateColumnTemplate = (
  rowData: TalhaoRow,
  options: ColumnBodyOptions,
) => dayjs(get(rowData, options.field)).format('DD/MM/YYYY');

export const numberColumnTemplate = (
  rowData: TalhaoRow,
  options: ColumnBodyOptions,
) => formatNumber(get(rowData, options.field), NUMBER_FORMAT_OPTIONS);

export const doseTemplate = (
  rowData: AdubacaoRow,
  options: ColumnBodyOptions,
) => {
  const doseFormatted = formatNumber(
    get(rowData, options.field),
    NUMBER_FORMAT_OPTIONS,
  );

  return `${doseFormatted} ${rowData.unidade?.abreviatura}`;
};

type SaveErrorMessage = Pick<ToastMessage, 'detail' | 'sticky'>;

export const formatErrorMessage = (
  error: unknown,
  recordStatus: 'create' | 'edit',
): SaveErrorMessage => {
  const message = `Falha ao ${
    recordStatus === 'create' ? 'criar' : 'atualizar'
  } o registro.`;
  let additionalMessage = '';
  let sticky = true;

  if (error instanceof TalhaoError) {
    additionalMessage = error.message;
    sticky = false;
  } else {
    if (!isAxiosError(error) || !error.response) {
      return {
        detail: message,
        sticky,
      };
    }

    if (
      isObject(error.response?.data) &&
      'sem_empreendimento' in error.response.data &&
      isArray(error.response.data.sem_empreendimento)
    ) {
      const talhoesFormatted = chain(error.response.data.sem_empreendimento)
        .map((value: string) =>
          value.replace(' sem empreendimento cadastrado', '').toUpperCase(),
        )
        .uniq()
        .join(', ')
        .value();

      additionalMessage = `${talhoesFormatted} sem empreendimento.`;
    }
  }

  if (additionalMessage) {
    return {
      detail: (
        <p className="text-danger-strong">{`${message} \n${additionalMessage}`}</p>
      ),
      sticky,
    };
  }

  return {
    detail: <p className="text-danger-strong">{message}</p>,
    sticky,
  };
};
